import http from '../http-common';
import store from '../store';

var _envReady = null;

function envReady() {
	if (_envReady) return _envReady;
	var api = store.state.env.get('VUE_APP_API_LINK');
	if (api !== undefined) {
		_envReady = Promise.resolve(api);
		return _envReady;
	}
	_envReady = new Promise(function(resolve) {
		var intervalID = setInterval(function() {
			var api = store.state.env.get('VUE_APP_API_LINK');
			if (api !== undefined) {
				clearInterval(intervalID);
				resolve(api);
			}
		}, 50);
	});
	return _envReady;
}

class APIService {
    fetch ({ method, path, data }) {
		return envReady().then(function(api) {
			http.defaults.baseURL = api;

			var response;

			switch (method) {
				case 'post':
					response = http.post(path, data).catch(funcError);
					break;

				case 'put':
					response = http.put(path, data).catch(funcError);
					break;

				case 'delete':
					response = http.delete(path).catch(funcError);
					break;

				default:
					response = http.get(path).catch(funcError);
			}

			return response;
		});
	}
}

const funcError = (error) => {
	if(!error.response)
	{
		return Promise.reject(error);
	}
	switch (error.response.status) {
		case 401:
			window.location.hash = '#/login';
			break
		default:
			break
	}
	return Promise.reject(error);
};

export default new APIService();